import React from 'react';
import { ChevronRight } from '../../icons';

export const WelcomeScreen = ({ setShowingWelcomeScreen }) => {
  return (
    <div className="text-center prose max-w-[--page-content-w] mx-auto w-full p-4 sm:p-8 lg:p-20 border-2 rounded-lg box-border border-neutral-200 shadow-lg bg-white">
      <div className="w-full flex justify-between items-center">
        <h1 className="m-0 text-left">
          Normalizacja meteorologiczna zanieczyszczeń powietrza (NORM AIR)
        </h1>
        <a
          href="https://www.youtube.com/watch?v=3wWYEAw_W44&list=PLsr7358AKbHrVSgDYDyxCuae8mXe5Risx&index=5"
          target="_blank"
          className="btn btn-outline btn-sm gap-2 whitespace-nowrap flex-shrink-0 shadow shadow-primary"
          rel="noopener noreferrer"
          title="Zobacz samouczek video"
        >
          <span
            className="hidden"
            dangerouslySetInnerHTML={{
              __html:
                '<!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->',
            }}
          ></span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
            className="h-4 w-4"
            fill="currentColor"
          >
            <path d="M0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2l0 256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1l0-17.1 0-128 0-17.1 14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z" />
          </svg>
          Samouczek
        </a>
      </div>
      <p className="text-left sm:text-justify mt-12">
        NORM AIR to zaawansowane narzędzie analityczne służące do przetwarzania
        i analizy dużych zbiorów danych dotyczących jakości powietrza. Celem
        modułu jest dostarczanie użytkownikom precyzyjnych, nieparametrycznych
        estymacji trendów wybranych parametrów środowiskowych, bezpośrednio
        powiązanych z efektami transformacji energetycznej. Dzięki procesowi
        normalizacji meteorologicznej, narzędzie pozwala oddzielić wpływ
        warunków meteorologicznych od innych czynników kształtujących
        obserwowane zmiany jakości powietrza. Umożliwia to bardziej wiarygodną
        ocenę wpływu działań z zakresu transformacji energetycznej na stężenia
        zanieczyszczeń oraz gazów cieplarnianych.
      </p>
      <p className="text-left sm:text-justify">
        NORM AIR wyróżnia się modularną strukturą, umożliwiającą elastyczne
        zarządzanie danymi i prowadzenie kompleksowych analiz – od wczytania
        danych po modelowanie i wizualizację wyników.
      </p>

      <div className="divider my-8"></div>

      <h3 className="text-left mt-8 mb-4">Docelowa grupa użytkowników:</h3>
      <ul className="text-left list-disc list-inside space-y-2">
        <li>Administracja publiczna / Sektor publiczny</li>
        <li>
          Biznes / Przedsiębiorstwa z sektora energetycznego i przemysłowego
        </li>
        <li>Organizacje non-profit / NGO zajmujące się ochroną środowiska</li>
        <li>Szkolnictwo / Edukacja (instytucje badawcze i uczelnie)</li>
      </ul>

      <h3 className="text-left mt-8 mb-4">
        Najważniejsze korzyści dla użytkowników:
      </h3>
      <ul className="text-left list-disc list-inside space-y-2">
        <li>
          możliwość oddzielenia efektów meteorologicznych od zmian wynikających
          z transformacji energetycznej,
        </li>
        <li>
          monitorowanie długoterminowych trendów jakości powietrza i gazów
          cieplarnianych,
        </li>
        <li>
          identyfikacja skuteczności działań proekologicznych i regulacyjnych,
        </li>
        <li>
          łatwe importowanie, przetwarzanie i wizualizowanie danych dzięki
          intuicyjnemu interfejsowi,
        </li>
        <li>
          tworzenie modeli statystycznych z wykorzystaniem metod uczenia
          maszynowego (supervised learning),
        </li>
        <li>
          wsparcie w podejmowaniu decyzji dotyczących planowania polityk
          środowiskowych i energetycznych.
        </li>
      </ul>

      <h3 className="text-left mt-8 mb-4">Przykładowe zastosowanie:</h3>
      <p className="text-left sm:text-justify">
        NORM AIR może być wykorzystany przez instytucje publiczne do oceny
        skuteczności lokalnych i krajowych programów redukcji emisji, przez
        firmy energetyczne do analizy wpływu swoich działań na jakość powietrza,
        a także przez naukowców do modelowania zależności pomiędzy warunkami
        meteorologicznymi a stężeniami zanieczyszczeń.
      </p>

      <button
        className="btn btn-lg btn-success mt-8"
        onClick={() => setShowingWelcomeScreen(false)}
      >
        Rozpocznij pracę <ChevronRight className={'size-6'} />
      </button>
    </div>
  );
};
